
@if (labelSize() === "small") {
  <div class="label-small">{{ field().label }}</div>
} @else {
  <mat-label>{{ field().label }}</mat-label>
}
<mat-form-field [formGroup]="parentForm()">
  <textarea
    matInput
    [formControlName]="field().key"
    class="body1 underlined-form-field-input"
    [placeholder]="field().placeholder"
    [required]="field().required"
    [attr.aria-required]="field().required"
    [attr.rows]="rows()"
    [attr.cols]="columns()"
    [minlength]="minLength()"
    [maxlength]="maxLength()"
  ></textarea>
</mat-form-field>
<div id="feedback">
  <div>
    @if (hasErrors) {
      <mat-error>{{ errorsList[0] }}</mat-error>
    }
  </div>
  @if (showCharacterCounter() && maxLength()) {
    <div
      class="character-counter"
      [class.at-limit]="isAtMaxLength"
      [class.near-limit]="isNearMaxLength"
    >
      {{ currentLength }}/{{ maxLength() }}
    </div>
  }
</div>
